'use client'

import { ReactNode } from 'react'
import { WagmiProvider } from 'wagmi'
import { RainbowKitProvider, getDefaultConfig, lightTheme } from '@rainbow-me/rainbowkit'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { mainnet, sepolia } from 'wagmi/chains'
import { Toaster } from 'react-hot-toast'
import '@rainbow-me/rainbowkit/styles.css'

// const localhost = defineChain({
//   id: 31337,
//   name: 'Localhost',
//   nativeCurrency: {
//     decimals: 18,
//     name: 'Ether',
//     symbol: 'ETH',
//   },
//   rpcUrls: {
//     default: {
//       http: ['http://localhost:8545'],
//     },
//   },
// })

// const worldchain = defineChain({
//   id: 480,
//   name: 'World Chain',
//   nativeCurrency: {
//     decimals: 18,
//     name: 'Ether',
//     symbol: 'ETH',
//   },
//   rpcUrls: {
//     default: {
//       http: ['https://worldchain-mainnet.g.alchemy.com/public'],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: 'Worldscan',
//       url: 'https://worldscan.org',
//     },
//   },
// })

// const worldchainSepolia = defineChain({
//   id: 4801,
//   name: 'World Chain Sepolia',
//   nativeCurrency: {
//     decimals: 18,
//     name: 'Ether',
//     symbol: 'ETH',
//   },
//   rpcUrls: {
//     default: {
//       http: ['https://worldchain-sepolia.g.alchemy.com/public'],
//     },
//   },
//   blockExplorers: {
//     default: {
//       name: 'World Chain Sepolia Explorer',
//       url: 'https://worldchain-sepolia.explorer.alchemy.com',
//     },
//   },
//   testnet: true,
// })

const config = getDefaultConfig({
  appName: 'TinyCloud Registry',
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'fallback-project-id',
  chains: [mainnet, sepolia],
  ssr: false,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={lightTheme()} showRecentTransactions={true}>
          {children}
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
                borderRadius: '8px',
                padding: '12px 16px',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
